import type { StopResult, TimeEntry, TimerSnapshot } from '../types';
import { http } from '@/shared/api/httpClient';
import type { PageResponse } from '@/shared/api/page';

export const timeApi = {
  timer: () => http.get<TimerSnapshot | ''>('/time/timer').then((r) => (r.status === 204 || r.data === '' ? null : r.data)),
  start: (taskId: string) =>
    http.post<TimerSnapshot>('/time/timer/start', { taskId }, { headers: { 'Idempotency-Key': crypto.randomUUID() } }).then((r) => r.data),
  stop: () => http.post<StopResult>('/time/timer/stop', null, { headers: { 'Idempotency-Key': crypto.randomUUID() } }).then((r) => r.data),
  entries: (params: { taskId?: string; userId?: string; from?: string; to?: string; page?: number; size?: number }) =>
    http.get<PageResponse<TimeEntry>>('/time/entries', { params }).then((r) => r.data),
  log: (body: { taskId: string; startedAt: string; minutes: number; note?: string }) => http.post<TimeEntry>('/time/entries', body).then((r) => r.data)
};
